import React from 'react';
import VenueCard from './offerCard';
import {connect} from 'react-redux';
import {fetchOffers} from '../../action/apiCallActions';




class List extends React.Component{
  constructor(props) {
     super(props);

   }

 componentDidMount() {
   if(this.props.offers.length < 1){
     this.props.dispatch(fetchOffers( {lat: 24.3865729, lng : 54.2784165}));
   }
 }


    render(){
       try{
       if(this.props.offers.length > 0){
       var offerList = this.props.offers.map((offer, i) => {
         var style = (i+1) % 3 == 0 ? "card " : " card card-margin";
           return (
             <VenueCard style={style} offerDetail={offer} key={i}  />
           );
       });
       }

       }catch(err){

       }

      return (

        <div className="jumbotron all-cards">

         {this.props.loader ? <span /> : offerList}


          </div>
      );
    }

}

function mapStateToProps(state) {
  return {
    offers : state.Offers,
  };
}

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./src/components/Offers/infiniteScroll.js